import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const countsService = {
  BalansGet,
  CountersGet,
  TransactionsGet,
  TariffPlansGet,
  UserTariffPlansRequestGet,
  TariffPlanRequestCreate,
  TariffPlanRequestCancel,
  UserTariffPlanGet,
  getDiskSpaceDetails
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'Counts'
};

function extract(r) {
  return r.data;
}

async function BalansGet() {
  return axios.get(model.baseUrl + 'Counts/BalansGet');
}

async function TariffPlansGet() {
  return axios.get(model.baseUrl + 'Counts/TariffPlansGet');
}

async function UserTariffPlansRequestGet() {
  return axios.get(model.baseUrl + 'Counts/UserTariffPlansRequestGet');
}

async function TransactionsGet(pCountCode, pDateBegin, pDateEnd) {
  return axios.get(
    model.baseUrl +
    'Counts/TransactionsGet?pCountCode=' +
    pCountCode +
    '&pDateBegin=' +
    (pDateBegin ? encodeURI(pDateBegin) : '') +
    '&pDateEnd=' +
    (pDateEnd ? encodeURI(pDateEnd) : '')
  ).then(extract);
}

async function CountersGet(myOrganizationCode: string = '', isOrgCounters: boolean = false) {
  return axios.get(model.baseUrl + `Counts/CountersGet?myOrganizationCode=${myOrganizationCode || ''}&isOrgCounters=${isOrgCounters}`);
}

async function TariffPlanRequestCreate(pTariffPlanCode) {
  return axios.post(model.baseUrl + 'Counts/TariffPlanRequestCreate', { pTariffPlanCode });
}

async function TariffPlanRequestCancel(pUserTarifPlanRequesCode) {
  return axios.post(model.baseUrl + 'Counts/TariffPlanRequestCancel', {
    pUserTarifPlanRequesCode: pUserTarifPlanRequesCode
  });
}

async function UserTariffPlanGet() {
  return axios.get(`${model.baseUrl}${model.controller}/UserTariffPlan`).then(extract);
}

async function getDiskSpaceDetails(): Promise<Array<any>> {
  let { data } = await axios.get<Array<any>>(`${model.baseUrl}${model.controller}/DiskSpaceDetailsGet`);

  return data;
}
